export default __webpack_public_path__ + "static/media/a.e44a45db.png";